import { render, staticRenderFns } from "./ColorMatchSwatchSelector.vue?vue&type=template&id=4b0935a0&scoped=true&lang=pug&"
import script from "./ColorMatchSwatchSelector.vue?vue&type=script&lang=js&"
export * from "./ColorMatchSwatchSelector.vue?vue&type=script&lang=js&"
import style0 from "./ColorMatchSwatchSelector.vue?vue&type=style&index=0&id=4b0935a0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0935a0",
  null
  
)

export default component.exports